// @flow

import React from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

type MobileMenuProps = {
  menu: PropTypes.any.isRequired,
};

/* eslint-disable react/no-array-index-key */
const MobileMenu = ({ menu }: MobileMenuProps): React.Element<any> =>
  (<div className="site-menu">
    <div className="site-menu__toggle theme--dark-blue">
      <button
        onClick={() => {
          if (global.document.body.classList.contains('js-menu--open')) {
            global.document.body.classList.remove('js-menu--open');
            global.document.body.scrollTop = this.previousScroll;
          } else {
            this.previousScroll = global.document.body.scrollTop;
            global.document.body.classList.add('js-menu--open');
            global.document.body.scrollTop = 0;
          }
        }}
        className="btn btn--circle btn--menu"
      >
        <span className="visually-hidden">Menu</span>
        <span className="btn__line btn__line--1" />
        <span className="btn__line btn__line--2" />
        <span className="btn__line btn__line--3" />
        <span className="btn__line btn__line--4" />
      </button>
    </div>

    <nav className="site-menu__menu theme__bg">
      <h2 className="site-menu__title h2 theme--white">Main Menu</h2>
      <ul className="list">
        {menu.links.map((menuItem, delta) =>
          (<li
            key={`main:${delta}`}
            className="site-menu__menu-item--level-1 list__item"
          >
            {menuItem.route.alias === '/'
              ? <button
                className="btn h3 h3--large has-arrow has-arrow--down"
                onClick={event => {
                  event.target.classList.toggle('has-arrow--down');
                }}
              >
                {menuItem.label}
              </button>
              : <NavLink
                to={menuItem.route.alias}
                activeClassName="is-active"
                className="h3 h3--large"
              >
                {menuItem.label}
              </NavLink>}
            {menuItem.links.length
              ? <ul className="list">
                {menuItem.links.map((menuItemChild, delta2) =>
                    (<li
                      key={`main:child:${delta2}`}
                      className="site-menu__menu-item--level-2 list__item"
                    >
                      <NavLink
                        to={menuItemChild.route.alias}
                        activeClassName="is-active"
                      >
                        {menuItemChild.label}
                      </NavLink>
                    </li>),
                  )}
              </ul>
              : ''}
          </li>),
        )}
      </ul>
    </nav>
  </div>);
/* eslint-enable react/no-array-index-key */

const query = gql`
  query mainNavigation($menu_name: String!) {
    menuByName(name: $menu_name) {
      links {
        ...Item
        links {
          ...Item
        }
      }
    }
  }

  fragment Item on MenuLink {
    label
    route: url {
      alias
    }
  }
`;

const withQuery = graphql(query, {
  options: () => ({
    variables: {
      menu_name: 'main',
    },
  }),
  props: ({ data: { menuByName } }: any): MobileMenuProps => ({
    menu: menuByName,
  }),
});

export default withQuery(MobileMenu);



// WEBPACK FOOTER //
// ./screens/App/components/MobileMenu/index.js